import * as React from 'react';
import * as styles from './styles.css';

import { ArticleParagraph2, ArticleHeading4, Responsive } from '@cian/ui-kit';

import { ETabs } from '../../types/redux/tabs';
import { getCardUrl } from '../../utils/openCard/getCardUrl';

export interface IAgencyCardProps {
  previewImg: React.ReactNode;
  age: string;
  agentId: number;
  name: string;
  offersCount: string;
  services: string;
  onClick(): void;
  levelNumber?: number | null;
  levelName?: string | null;
  participations: React.ReactNode;
  superAgentBadge: React.ReactNode;
}

export function AgencyCard({
  previewImg,
  age,
  agentId,
  name,
  offersCount,
  services,
  onClick,
  participations,
  superAgentBadge,
}: IAgencyCardProps) {
  // Ссылка нужна, чтобы поисковый бот находил страницы агентств. Переход и аналитика — в onClick карточки
  const handleNameClick = (e: React.MouseEvent<HTMLAnchorElement>) => e.preventDefault();

  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['one-column']}>
        <div className={styles['img']}>{previewImg}</div>
        <div className={styles['text-info']}>
          <div className={styles['name']}>
            <ArticleHeading4>
              <a className={styles['agent-name']} href={getCardUrl(ETabs.Agencies, agentId)} onClick={handleNameClick}>
                {name}
              </a>
              <div className={styles['participations']}>{participations}</div>
            </ArticleHeading4>
          </div>
          {superAgentBadge && <div className={styles['badge']}>{superAgentBadge}</div>}
          <div>
            <ArticleParagraph2 color="black_60">{age}</ArticleParagraph2>
          </div>
        </div>
      </div>
      <div className={styles['two-column']}>
        <Responsive desktop>
          <div className={styles['services']}>
            <ArticleParagraph2>{services}</ArticleParagraph2>
          </div>
        </Responsive>
        <div className={styles['work']}>
          <div>
            <ArticleHeading4>{offersCount}</ArticleHeading4>
          </div>
          <div>
            <ArticleParagraph2 color="black_60">в работе</ArticleParagraph2>
          </div>
        </div>
      </div>
    </div>
  );
}
